<template>
  <footer class="te-footer bg-co-gray-700">
    <div class="co-container-lg px-4 py-5">
      <slot name="top-menu" />

      <div class="flex flex-col gap-4 text-[0.75rem] md:flex-row">
        <ul class="mr-auto flex flex-wrap gap-x-6 gap-y-2">
          <li>
            <a
              href="/company"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              運営会社
            </a>
          </li>
          <li>
            <a
              href="/terms"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              利用規約
            </a>
          </li>
          <li>
            <a
              href="/privacypolicy"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              プライバシーポリシー
            </a>
          </li>
          <li class="mb-2">
            <a
              href="/law"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              特定商取引法に関する表示
            </a>
          </li>
          <li class="mb-2">
            <a
              href="/benefits/reskilling-notice"
              class="block p-0 text-co-gray-500 hover:text-co-gray-500"
            >
              リスキリングを通じたキャリアアップ支援事業に関する重要なお知らせ
            </a>
          </li>
        </ul>
      </div>

      <div class="text-center text-co-gray-500">
        <small class="text-[0.875em]">&copy;&nbsp;{{ currentYear }}&nbsp;Brewus,Inc.</small>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useDateFormat, useNow } from '@vueuse/core'

const currentYear = useDateFormat(useNow(), 'YYYY')
</script>
